import { combineEpics } from 'redux-observable'

import Epic from './Epic'
import operations from './operations'
import routes from './routes'
import shared from './shared'
import world from './world'

export default combineEpics<Epic>(shared, operations, world, routes)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/index.ts